import { Directive } from '@angular/core';

@Directive({
  selector: '[tooltipHeader]',
  standalone: false,
})
export class TooltipHeaderDirective {}
